"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameState = exports.RoundType = void 0;
var RoundType;
(function (RoundType) {
    RoundType[RoundType["Null"] = 0] = "Null";
    RoundType[RoundType["Standard"] = 1] = "Standard";
})(RoundType || (exports.RoundType = RoundType = {}));
var GameState;
(function (GameState) {
    GameState[GameState["Init"] = 0] = "Init";
    GameState[GameState["InProgress"] = 1] = "InProgress";
    GameState[GameState["AutoFinish"] = 2] = "AutoFinish";
    GameState[GameState["EndingAnimation"] = 3] = "EndingAnimation";
    GameState[GameState["Finished"] = 4] = "Finished";
})(GameState || (exports.GameState = GameState = {}));
